// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"b7afe5a4","68":"82388c07","96":"1742f82f","136":"0f1acb26","176":"27022080","364":"9d508ea9","368":"fe371d32","592":"fa115f37","640":"0809a292","796":"36f990dd","824":"ac55660e","828":"a37e677f","836":"86f677a0","962":"e3209d3f","980":"3fcfc7b1"}[chunkId] + ".chunk.js";
};